// src/main.tsx
import * as Sentry from '@sentry/react'
import {
  buildInitOptions,
  installSentryVerificationHarness,
  isSentryClientVerificationEnabled,
} from '@alexai/sentry-config'
import {createRoot} from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import {registerSW} from 'virtual:pwa-register'

Sentry.init(buildInitOptions("etp-member-portal", {
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
  release: import.meta.env.VITE_SENTRY_RELEASE,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
}))
installSentryVerificationHarness(
  "etp-member-portal",
  isSentryClientVerificationEnabled(
    import.meta.env.VITE_SENTRY_VERIFICATION_ENABLED,
  ),
)

// 1. Register the Service Worker
registerSW({immediate: true})

// 2. Render the App
createRoot(document.getElementById('root')!).render(
    <App/>
)
